import _ from 'lodash-es';
import carouselHTML from './carouselHTML';

export default (product_json, variant_image_map, $carousels_data, $container) => {
  const carousel_images = [];

  _.each(product_json.images, (image) => {
    const image_without_query = image.split('?')[0];

    carousel_images.push({ 
      src: image,
      variants: variant_image_map[image_without_query],
    });
  });

  const carousel_html = carouselHTML($carousels_data, carousel_images, `ProductCarousel${product_json.id}`);
  $('[data-product-images-carousels]', $container).append(carousel_html);
  // Manually set this as the "active" carousel since there are no other carousels...
  $(`#ProductCarousel${product_json.id}`).addClass('ProductImages__carousel--active');
  $(`#ProductCarousel${product_json.id}-Thumbs`).addClass('ProductImages__thumbs--active');

  $(document).trigger('productOverviewCarouselsDidPopulate', 'all');
};